import { BaseModel } from '@core/data-access';
import { Expose } from 'class-transformer';
import * as moment from 'moment';
import { Default } from '@core/util';

export interface IDocumentExpirationSetting {
  enableExpiration: boolean;
  expireAfter: number; // the number of day before expire
  notifyBefore: number; // the number of day prior to expiration to warn signer
  expireAfterUnit: string;
  startDate: string;
}

export class DocumentExpirationSettingModel extends BaseModel implements IDocumentExpirationSetting {
  @Expose()
  enableExpiration!: boolean;

  @Expose()
  expireAfter!: number;

  @Expose()
  @Default('days')
  expireAfterUnit!: string;

  @Expose()
  notifyBefore!: number;

  @Expose()
  startDate!: string;

  @Expose()
  get expirationDate() {
    if (!this.startDate || !this.expireAfter) {
      return null;
    }
    return moment(this.startDate).add(this.expireAfter + 1, this.expireAfterUnit as moment.unitOfTime.DurationConstructor);
  }
}
